import React, { useState } from 'react';

const ProposalModal = ({ isOpen, onClose }) => {
  const [status, setStatus] = useState('');


  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
    setStatus('Sending...');

    fetch('/.netlify/functions/submitForm', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })

      .then((response) => {
        if (!response.ok) throw new Error('Request failed');
        setStatus('Proposal sent successfully.');
        e.target.reset();
      })
      .catch(() => {
        setStatus('This works only after Netlify deployment. Local preview will fail.');
      });
  };

  if (!isOpen) return null;

  return (
    <div id="proposalModal" className="proposal-modal is-open" aria-hidden="false" role="dialog" aria-labelledby="proposalTitle">
      <div className="proposal-modal__backdrop" onClick={onClose}></div>
      <div className="proposal-modal__panel">
        <button type="button" className="proposal-modal__close" aria-label="Close proposal form" onClick={onClose}>&times;</button>
        <div className="proposal-modal__header">
          <p className="proposal-modal__eyebrow">Start a project</p>
          <h2 id="proposalTitle">Project proposal form</h2>
          <p>Fill this in and it will go to Netlify Forms after deployment.</p>
        </div>
        <form id="proposalForm" name="project-proposal" method="POST" data-netlify="true" netlify-honeypot="bot-field" className="proposal-form" onSubmit={handleSubmit}>
          <input type="hidden" name="form-name" value="project-proposal" />
          <p hidden>
            <label>Don’t fill this out if you're human: <input name="bot-field" /></label>
          </p>
          <div className="proposal-form__grid">
            <label><span>Name</span><input type="text" name="name" required /></label>
            <label><span>Email</span><input type="email" name="email" required /></label>
            <label><span>Company</span><input type="text" name="company" /></label>
            <label><span>Phone</span><input type="tel" name="phone" /></label>
            <label><span>Project type</span>
              <select name="project_type" required defaultValue="">
                <option value="" disabled>Select one</option>
                <option>AI SaaS product</option>
                <option>Custom AI solution</option>
                <option>Advisory / strategy</option>
                <option>Automation / integration</option>
                <option>Other</option>
              </select>
            </label>
            <label><span>Estimated budget</span>
              <select name="budget" required defaultValue="">
                <option value="" disabled>Select one</option>
                <option>Under $10,000</option>
                <option>$10,000 - $25,000</option>
                <option>$25,000 - $50,000</option>
                <option>$50,000+</option>
                <option>Not sure yet</option>
              </select>
            </label>
          </div>
          <label><span>Project summary</span><textarea name="summary" required></textarea></label>
          <label><span>Timeline</span><textarea name="timeline"></textarea></label>
          <div className="proposal-form__actions">
            <div id="proposalStatus" className="proposal-form__status" aria-live="polite">{status}</div>
            <button type="submit" className="proposal-form__submit">Send proposal</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProposalModal;